module.exports = __webpack_public_path__ + "img/decorator-headphones.c0a072d7.png";